module.exports = __webpack_public_path__ + "static/media/telethon-logo-horizontal.fec94724.svg";